import * as React from 'react';
import styled from 'styled-components';
import {ConstBreakPoint, ConstMargin} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.TableHTMLAttributes<HTMLTableElement>, HTMLTableElement> {
}

const TableDefault: React.FC<IProps> = (props) => {

    const { ...TableProps } = props;

    return(<table {...TableProps} />);

};

const Table = styled(TableDefault)`
    width: 100%;
    table-layout: fixed;
    display: block;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        display: table;
        border-collapse: separate;
        border-spacing: 0 ${ConstMargin.TableBorder};
    }
`;

export default Table;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/table/table.tsx